<template>
    <div class="flex justify-between items-center relative">
        <label class="flex flex-col md:flex-row">
            <div class="mr-8 mb-4 sm:mb-0">
                <input :id="id" :name="name" hidden type="checkbox" :checked="modelValue"
                    @change="$emit('update:modelValue', $event.target.checked)" />
                <span class="checkbox-switch w-fit relative  bg-red-600 rounded-full px-1 py-1 flex items-center space-x-2">
                    <span
                        class="uppercase cursor-pointer text-xs pl-1 pr-2 py-1 bg-transparent rounded-full z-20 transition-all duration-100 ease-in text-white"
                        id="second_option">{{ $t('registration.yes') }}</span>
                    <span
                        class="uppercase cursor-pointer text-xs px-2 py-1 bg-transparent rounded-full z-20 transition-all duration-100 ease-in text-white"
                        id="first_option">{{ $t('registration.no') }}</span>
                </span>
            </div>
            <slot />
        </label>
    </div>
</template>

<script>
export default {
    props: ['id', 'name', 'checked', 'modelValue']
}
</script>